import React, {Component} from 'react';
import jsxToString from 'jsx-to-string';
import firebase from '../../Firebase';
import { food, food_groups, food_quantifiers, quantifiers_per_food, quantifiers_amounts, food_combination, nutritional_requirements_breastfed, nutritional_requirements_nonbreastfed } from '../constants';


class Feeding extends Component {
  constructor() {
    super();
    this.state = {
      response: {
        success: false,
        warning: null,
        error: null,
        message: null,
        deficiency_food_groups_menu: [],
        food_groups_deficiency_message: null,
        food_groups_ids: [],
        data: null,
        weight_status: null,
        height_status: null,
        weight_height_status: null,
        growth_problem: null,
        growth_problem_message: null,
        found_problem: false,
        warning_problem: null,
        problem_submitted: false,
        growth_message: null,
        insertID: null,
      }
    };
    
  }

  resetState = () => {
    const {insertID} = this.state.response;
    let response ={
      success: false,
      warning: null,
      error: null,
      message: null,
      data: null,
      weight_status: null,
      height_status: null,
      weight_height_status: null,
      growth_problem: null,
      growth_problem_message: null,
      found_problem: false,
      warning_problem: null,
      problem_submitted: false,
      growth_message: null,
      insertID: insertID,
    }

      this.state.response = response;

  }

  round = (value, decimals) => {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
  }

  getFeedingSuggestions = (Child, User) => {

    this.ProgressTableRef = firebase.firestore().collection('users').doc(User.key).collection('children').doc(Child.key).collection('children_progress').orderBy("recording_time", "asc");
   
    return this.ProgressTableRef.get().then((querySnapshot) => {
      if(!querySnapshot.empty){
        const data = [];
        const suggestions_data = [];
        const events_dates = [];
        const all_data = {};

        querySnapshot.forEach((doc) => {
          const row = doc.data();
          data.push(row);
        });
        
        data.reverse();//Reverse order of data array elements i.e from ascending to descending

        var i=0;
        var j;
        const count = data.length;
        var previous_date = '';
        for(j=0;j<count-1;j++) {
          
          const recording_time = new Date(data[j]['recording_time']);
          const event_year = recording_time.getFullYear();
          var event_month = recording_time.getMonth();
          event_month += 1;
          event_month = event_month < 10 ? '0'+event_month : event_month;
          const event_day = recording_time.getDate() < 10 ? '0'+recording_time.getDate() : recording_time.getDate();
          const event_date = event_year+'-'+event_month+'-'+event_day;

          if(j === 0){
            suggestions_data.push(data[j]);
            events_dates.push(event_date);
          }
          else{
            if(event_date === previous_date)
              continue;
            suggestions_data.push(data[j]);
            events_dates.push(event_date);
          }
          previous_date = event_date;
        }
         all_data.advice_dates = events_dates;
         all_data.advice_records = data;
        return {success: true, error: null, data: all_data};
      }
      else{
        return {success: false, error: 'No suggestions recorded for this child', data: []};
        // window.history.back();
      }

    }).catch((error) => {
      return {success: false, error: "Suggestions can't be fetched("+error+")", data: []};
      // window.history.back();
    });

  }

  showMilkFrequency = (option, translation) => {
    let output = '';
    if(option == 'Yes' || option == 'Ndiyo'){
      option = jsxToString(<option value="">0</option>);;
      var j;
      for(j = 1; j <= 20; j++){
        option += jsxToString(<option value={`${j}`}>{j}</option>);
      }
      output = option;
    }
    else
      output = null;

    return output;

  }

  showMealList = (option, translation) => {
    let output = null;
    if(option == 'Yes' || option == 'Ndiyo'){
      let food_list = '';
      if(translation['language'] == 'swahili'){
        food_list = food.map((food) => ({ label: food['food_name_swahili'], value: food['food_id']})
        );
      }
      else{
        food_list = food.map((food) => ({ label: food['food_name'], value: food['food_id']})
        );
      }
      output = food_list;
        
    }
    else
      output = null;

    return output;
  }

 updateFeedingMessages = (message, warning, breastfeeding, breastfrequency, feeding, energy, protein, vitaminA, vitaminC, vitaminD, vitaminE, progress_id,Child, User, age) => {
    const childID = Child.child_id;
    const child_key = Child.key;
    const user_key = User.key;
    var meal_feeding = '';
    const breast_feeding = breastfeeding;
    const breast_frequency = breastfrequency;
    const {total_months,total_weeks,total_days} = age;
    if(feeding != null)
      meal_feeding = feeding['meal_feeding'];

    if(progress_id === 0){
      let currentTime= new Date();
      progress_id = childID+""+currentTime.getTime();

      let Year = currentTime.getUTCFullYear() < 10 ? "0"+currentTime.getUTCFullYear() : currentTime.getUTCFullYear();
      let Month = currentTime.getUTCMonth();
      Month += 1;
      Month = Month < 10 ? "0"+Month : Month;
      let Datex = currentTime.getUTCDate() < 10 ? "0"+currentTime.getUTCDate() : currentTime.getUTCDate();
      let Hours = currentTime.getUTCHours() < 10 ? "0"+currentTime.getUTCHours() : currentTime.getUTCHours();
      let Minutes = currentTime.getUTCMinutes() < 10 ? "0"+currentTime.getUTCMinutes() : currentTime.getUTCMinutes();
      let Seconds = currentTime.getUTCSeconds() < 10 ? "0"+currentTime.getUTCSeconds() : currentTime.getUTCSeconds();
      let currentDateTime = Year+"-"+Month+"-"+Datex+" "+Hours+":"+Minutes+":"+Seconds;

      this.AddProgressTableRef = firebase.firestore().collection("users").doc(user_key).collection("children").doc(child_key).collection('children_progress');
      this.AddProgressTableRef.doc(progress_id).set(
        {
          "child_progress_id": progress_id,
          "weight": "",
          "height": "",
          "hiv_status": "",
          "milk_feeding": breast_feeding,
          "milk_feeding_frequency": breast_frequency,
          "meal_feeding": meal_feeding,
          "energy": energy,
          "protein": protein,
          "vitaminA": vitaminA,
          "vitaminC": vitaminC,
          "vitaminD": vitaminD,
          "vitaminE": vitaminE,
          "bmi_message": "",
          "bmi_warning": "",
          "feeding_message": message,
          "feeding_warning": warning,
          "child_id": childID,
          "months": total_months,
          "weeks": total_weeks,
          "days": total_days, 
          "recording_time": currentDateTime
        }
      ).catch((error) => {
        alert("Advice messages was not Saved"+"("+error+")");
        // this.state.response.success = false;
        // return false
      });
    }
    else{
      this.AddProgressTableRef = firebase.firestore().collection("users").doc(user_key).collection("children").doc(child_key).collection('children_progress');
      this.AddProgressTableRef.doc(progress_id).update(
        {
          "feeding_message": message,
          "feeding_warning": warning,
          "milk_feeding": breast_feeding,
          "milk_feeding_frequency": breast_frequency,
          "meal_feeding": meal_feeding,
          "energy": energy,
          "protein": protein,
          "vitaminA": vitaminA,
          "vitaminC": vitaminC,
          "vitaminD": vitaminD,
          "vitaminE": vitaminE
        }
      ).catch((error) => {
        alert("Advice messages was not Saved"+"("+error+")");
        // this.state.response.success = false;
        // return false
      });
    }
    
    if(feeding !== null){
      const food_data = feeding['food_data'];
      food_data.forEach((food) => {
        const food_id = food['food_id'];
        const quantity = food['quantity'];
        const quantity_frequency = food['quantity_frequency'];
        const consistency = food['consistency'];
        const time = food['time'];

        let currentTime= new Date();
        let feeding_practice_id = childID+""+currentTime.getTime();
        this.AddProgressTableRef = firebase.firestore().collection("users").doc(user_key).collection("children").doc(child_key).collection('children_progress').doc(progress_id).collection('feeding_practices');
        
        let Year = currentTime.getUTCFullYear() < 10 ? "0"+currentTime.getUTCFullYear() : currentTime.getUTCFullYear();
        let Month = currentTime.getUTCMonth();
        Month += 1;
        Month = Month < 10 ? "0"+Month : Month;
        let Datex = currentTime.getUTCDate() < 10 ? "0"+currentTime.getUTCDate() : currentTime.getUTCDate();
        let Hours = currentTime.getUTCHours() < 10 ? "0"+currentTime.getUTCHours() : currentTime.getUTCHours();
        let Minutes = currentTime.getUTCMinutes() < 10 ? "0"+currentTime.getUTCMinutes() : currentTime.getUTCMinutes();
        let Seconds = currentTime.getUTCSeconds() < 10 ? "0"+currentTime.getUTCSeconds() : currentTime.getUTCSeconds();
      
        let currentDateTime = Year+"-"+Month+"-"+Datex+" "+Hours+":"+Minutes+":"+Seconds;
        this.AddProgressTableRef.add(
        {
          "feeding_practice_id": feeding_practice_id,
          "food_id": food_id,
          "quantifier": quantity,
          "amount": quantity_frequency,
          "consistency": consistency,
          "time": time,
          "child_progress_id": progress_id,
          "child_id": childID,
          "recording_time":  currentDateTime
        }).catch((error) => {
          alert("Advice messages was not Saved"+"("+error+")");
          // this.state.response.success = false;
          // return false
        });

      });
    }

  }

  getBreastFeedingStatus = (feeding_options, Child, User, age, translation) => {
    const breast_feeding = feeding_options.breast_feeding;
    const breast_frequency = feeding_options.breast_frequency;

    const C_firstname = Child.first_name;
    const total_months = age.total_months;

    var child_progress_id = JSON.parse(localStorage.getItem('child_progress_id'));
    if(child_progress_id===null)
        child_progress_id = child_progress_id = 0;
        

    // <No value submitted for these variables>
    const meal_feeding = 'No';
    const total_no = 0;
    var all_food_data = [];
    // </No value submitted for these variables>

    // No food details
    var total_energy = 0.0;
    var total_protein = 0.0;
    var total_vitamin_A = 0.0;
    var total_vitamin_C = 0.0;
    var total_vitamin_D = 0.0;
    var total_vitamin_E = 0.0;

    var required_energy = 0.0;
    var required_protein_max = 0.0;
    var required_protein_min = 0.0;
    var required_vitamin_A_max = 0.0;
    var required_vitamin_A_min = 0.0;
    var required_vitamin_C_max = 0.0;
    var required_vitamin_C_min = 0.0;
    var required_vitamin_D_max = 0.0;
    var required_vitamin_D_min = 0.0;
    var required_vitamin_E_max = 0.0;
    var required_vitamin_E_min = 0.0;

    var message = '';
    var warning = '';
    var message_display = '';
    var warning_display = '';

    total_energy += breast_frequency * 25; //25 comes from 200/8;

    var feeding_data = {breast_feeding: breast_feeding, breast_frequency: breast_frequency, meal_feeding: meal_feeding, total_no: total_no, food_data: all_food_data};

    nutritional_requirements_breastfed.forEach((energy_requirement) => {
      if(energy_requirement['Age'] == total_months){
        required_energy = parseFloat(energy_requirement['ENERGY_KC']);
        required_protein_max = parseFloat(energy_requirement['PROCNT_MAX']);
        required_protein_min = parseFloat(energy_requirement['PROCNT_MIN']);
        required_vitamin_A_max = parseFloat(energy_requirement['VITA_MAX']);
        required_vitamin_A_min = parseFloat(energy_requirement['VITA_MIN']);
        required_vitamin_C_max = parseFloat(energy_requirement['VITC_MAX']);
        required_vitamin_C_min = parseFloat(energy_requirement['VITC_MIN']);
        required_vitamin_D_max = parseFloat(energy_requirement['VITD_MAX']);
        required_vitamin_D_min = parseFloat(energy_requirement['VITD_MIN']);
        required_vitamin_E_max = parseFloat(energy_requirement['VITE_MAX']);
        required_vitamin_E_min = parseFloat(energy_requirement['VITE_MIN']);
      }
    });

    if(total_energy >= required_energy){
      if(total_months >= 6){
        message +=  translation['feeding_practice_frequency_success_b_a']+" "+C_firstname+" "+translation['feeding_practice_frequency_success_b_b']+"</br>"+translation['feeding_practice_success_bigup_b'];
        warning += translation['feeding_practice_mealfeed_also_warning_a']+" "+C_firstname+" "+translation['feeding_practice_mealfeed_also_warning_b']+" "+translation['feeding_practice_mealfeed_also_warning_c']+" "+required_energy +"KCal "+ translation['feeding_practice_mealfeed_also_warning_d']+".<br/>"+translation['feeding_practice_mealfeed_also_warning_e']+" "+C_firstname+" "+translation['feeding_practice_mealfeed_also_warning_f'];
      }
      else{
        message +=  translation['feeding_practice_frequency_success_b_a']+" "+C_firstname+" "+translation['feeding_practice_frequency_success_b_b']+"</br>"+translation['feeding_practice_success_bigup_b'];
        warning_display = 'none';
      }
    }
    else{
      if(total_months >= 6){
        warning += "<b><font color='#aa0000'>"+translation['feeding_practice_warning_unbigup_a']+"</font></b><br/>"+translation['feeding_practice_frequency_warning_a_a']+" "+C_firstname+" "+translation['feeding_practice_frequency_warning_a_b']+"</br>"+translation['feeding_practice_frequency_warning_b']+" "+C_firstname+" "+translation['feeding_practice_frequency_warning_c']+"<br/>"+translation['feeding_practice_mealfeed_also_warning_g']+" "+C_firstname+" "+translation['feeding_practice_mealfeed_also_warning_c']+" "+required_energy +"KCal "+translation['feeding_practice_mealfeed_also_warning_d']+".<br/>"+translation['feeding_practice_mealfeed_also_warning_e']+" "+C_firstname+" "+translation['feeding_practice_mealfeed_also_warning_f'];
        message_display = 'none';
      }
      else{
        warning += translation['feeding_practice_frequency_warning_a_a']+" "+C_firstname+" "+translation['feeding_practice_frequency_warning_a_b']+"</br>"+translation['feeding_practice_frequency_warning_b']+" "+C_firstname+" "+translation['feeding_practice_frequency_warning_c']+".";
        message_display = 'none';
      }
    }

    const temp_message = message;
    const temp_warning = warning;

  this.updateFeedingMessages(temp_message,temp_warning,breast_feeding,breast_frequency,null,total_energy,total_protein,total_vitamin_A,total_vitamin_C,total_vitamin_D,total_vitamin_E,child_progress_id,Child,User,age);
      // $error = $child->error;

    // No food details

    this.state.response.feeding_message = message;
    this.state.response.feeding_warning = warning;
    this.state.response.message_display =  message_display;
    this.state.response.warning_display = warning_display;

    const feeding_nutrients = {total_energy: total_energy,required_energy: required_energy,total_protein: total_protein,required_protein_max: required_protein_max,required_protein_min: required_protein_min,total_vitamin_A: total_vitamin_A,total_vitamin_C: total_vitamin_C,total_vitamin_D: total_vitamin_D,total_vitamin_E: total_vitamin_E,required_vitamin_A_max: required_vitamin_A_max,required_vitamin_C_max: required_vitamin_C_max,required_vitamin_D_max: required_vitamin_D_max,required_vitamin_E_max: required_vitamin_E_max,required_vitamin_A_min: required_vitamin_A_min,required_vitamin_C_min: required_vitamin_C_min,required_vitamin_D_min: required_vitamin_D_min,required_vitamin_E_min: required_vitamin_E_min};

    this.state.response.feeding_nutrients = feeding_nutrients;
    return this.state.response;
  }

  getValue = (matrix, dimension) => {
    // $value = $d/$D;
    var value;
    const c1 = matrix[0][0];
    const total = matrix[0][3];

    if(dimension === 3) {
    
      const c2 = matrix[0][1];
      const c3 = matrix[0][2];

      var tempY = total/(2*c2);
      var tempZ = (total-(c2*tempY))/c3;
      var tempX = (c2*tempY)/c1;
      var Y = tempZ;
      var X = tempY;
      var Z = (total - (c1*X + c2*Y))/c3;

      if(X < 0 || Y < 0 || Z < 0){
        tempZ = total/(2*c3);
        tempX = (total-(c3*tempZ))/c1;
        Y = tempX;
        Z = tempZ;
        X = (total - (c2*Y + c3*Z))/c1;

      }
      if(X < 0 || Y < 0 || Z < 0){
      tempX = total/(2*c1);
      tempY = (total-(c1*tempX))/c2;
      Z = tempX;
      X = tempY;
      Y = (total - (c1*X + c3*Z))/c2;

      }

      value = [X, Y, Z];
    }

    else if(dimension === 2) {
      const c2 = matrix[0][1];

      var tempX = total/(c1);
      var Y = tempX;
      var X = (total - (c2*Y))/c1;

      if(X < 0 || Y < 0){
        tempY = total/(c2);
        X = tempY;
        Y = (total - (c1*X))/c2;
      }

       value = [X, Y];
    }

    else if(dimension === 1) {
      const X = total/c1;
      value = [X];
    }

    var v = 0;
    value.forEach((val) => {
      var val_temp;
      var val_int =  Math.floor(val);
      var val_dec = val-val_int;
      if(val_dec >= 0.1 && val_dec < 0.6)
        val_temp = val_int+0.5;
      else if(val_dec >= 0.6)
        val_temp = val_int+1;
      else
        val_temp = val_int;
      value[v] = val_temp;
      v++;
    });

    return value;
  }

  getSmartFeedingCombinations = (all_food_data, required_energy,required_protein_min, required_protein_max, required_vitamin_A_max, required_vitamin_A_min, C_firstname, total_months, translation) => {
    var combination_message='';
    var combination_message_temp='';
    const food_no = all_food_data.length;
    const foods = food;
    const quantifiers = food_quantifiers;
    const food_vs_quantifiers = food_combination;

    var combination = [[], [], []];
    var matrix = [[], [], []];
    var matrixX = [[], [], []];
    var matrixY = [[], [], []];
    var matriZ = [[], [], []];
    matrix[0][3] = required_energy;
    matrix[1][3] = required_protein_max;
    matrix[2][3] = required_vitamin_A_max;

    var food1 = {food: '', food_swahili:'', quantifier: '', quantifier_swahili: '', units:''};
    var food2 = {food: '', food_swahili:'', quantifier: '', quantifier_swahili: '', units:''};
    var food3 = {food: '', food_swahili:'', quantifier: '', quantifier_swahili: '', units:''};

    var no = 1;
    all_food_data.forEach((food_data) => {
      var food_temp;
      if(no == 1)
        food_temp = food1;
      else if(no == 2)
        food_temp = food2;
      else if(no == 3)
        food_temp = food3;

      food_vs_quantifiers.some((food_vs_quantifier) => {
        if(food_vs_quantifier['food_id'] == food_data['food_id']){

          quantifiers.some((quantifier) => {
            if(quantifier['food_quantifiers_id'] == food_vs_quantifier['food_quantifiers_id']){
              food_temp['quantifier'] = quantifier['food_quantifiers_name'];
              food_temp['quantifier_swahili'] = quantifier['food_quantifiers_name_swahili'];                                     

              foods.some((food) => {
                if(food['food_id'] == food_data['food_id']){
                  const unit_energy = (food_vs_quantifier['grams']/100)*food['ENERGY_KC'];
                  const unit_protein = (food_vs_quantifier['grams']/100)*food['PROCNT'];
                  const unit_vitaminA = (food_vs_quantifier['grams']/100)*food['VITA'];

                  food_temp['food'] = food['food_name'];
                  food_temp['food_swahili'] = food['food_name_swahili'];

                  matrix[0][no-1] = unit_energy;
                  matrix[1][no-1] = unit_protein;
                  matrix[2][no-1] = unit_vitaminA;

                  return true;
                }
              });

              return true;
            }
          });

          return true;
        }

      });

      if(no == 1)
        food1 = food_temp;
      else if(no == 2)
        food2 = food_temp;
      else if(no == 3)
        food3 = food_temp;

      no++;
    });

    const values = this.getValue(matrix, food_no);

    food1['units'] = values[0];
    combination[0] = food1;

    if(values.length === 2){
      food2['units'] = values[1];
      combination[1] = food2;
    }
    else if(values.length === 3){
      food2['units'] = values[1];
      food3['units'] = values[2];
      combination[1] = food2;
      combination[2] = food3;
    }

    if(translation['language'] == 'swahili') {
      const food_name1 = combination[0]['food_swahili'];
      const quantifier1 = combination[0]['quantifier_swahili'];
      const units1 = combination[0]['units'];

      combination_message_temp += jsxToString(
        <div>
          {" "+food_name1+" - "+quantifier1+" ("+units1+")<br/>"}
        </div>
      );

      if(food_no === 2){
        const food_name2 = combination[1]['food_swahili'];
        const quantifier2 = combination[1]['quantifier_swahili'];
        const units2 = combination[1]['units'];

        combination_message_temp += jsxToString(
          <div>
            {food_name2+" - "+quantifier2+" ("+units2+")<br/>"}
          </div>
        );
      }

      if(food_no == 3){
        const food_name2 = combination[1]['food_swahili'];
        const quantifier2 = combination[1]['quantifier_swahili'];
        const units2 = combination[1]['units'];
        const food_name3 = combination[2]['food_swahili'];
        const quantifier3 = combination[2]['quantifier_swahili'];
        const units3 = combination[2]['units'];

        combination_message_temp += jsxToString(
          <div>
            {food_name2+" - "+quantifier2+" ("+units2+")<br/>"+
            food_name3+" - "+quantifier3+" ("+units3+")<br/>"}
          </div>
        );
      }

      combination_message += jsxToString(
        <div>
          <br/>
          <div>{"Ili <b>"+C_firstname+"</b> atimize lishe kamili ndani ya masaa 24, apatiwe vyakula ulivyochagua kwa vipimo vifuatavyo:"}</div><br/>
        </div>
      );
        
    }
    else{
      const food_name1 = combination[0]['food'];
      const quantifier1 = combination[0]['quantifier'];
      const units1 = combination[0]['units'];

      combination_message_temp += jsxToString(
        <div>
          {food_name1+" - "+quantifier1+" ("+units1+")<br/>"}
        </div>
      );

      if(food_no === 2){
        const food_name2 = combination[1]['food'];
        const quantifier2 = combination[1]['quantifier'];
        const units2 = combination[1]['units'];

        combination_message_temp += jsxToString(
          <div>
            {food_name2+" - "+quantifier2+" ("+units2+")<br/>"}
          </div>
        );
      }

      if(food_no == 3){
        const food_name2 = combination[1]['food'];
        const quantifier2 = combination[1]['quantifier'];
        const units2 = combination[1]['units'];
        const food_name3 = combination[2]['food'];
        const quantifier3 = combination[2]['quantifier'];
        const units3 = combination[2]['units'];

        combination_message_temp += jsxToString(
          <div>
            {food_name2+" - "+quantifier2+" ("+units2+")<br/>"+
            food_name3+" - "+quantifier3+" ("+units3+")<br/>"}
          </div>
        );
      }

      combination_message += jsxToString(
        <div>
          <br/>
          <div>{"In order to get a balanced diet within 24 hours, <b>"+C_firstname+"</b> is required to get the following amount of the selected food:"}</div><br/>
        </div>
      );

    }

    combination_message += combination_message_temp;
    return combination_message;
  }

  getSmartFeedingMenu = (food_list, breast_feeding, Child, age, translation) => {

    var all_food_combinations = [];
    const all_food_data = [];
    const feeding_data = food_list;
    const total_months = age.total_months;
    const C_firstname = Child.first_name;

    var message = '';

    feeding_data.forEach((food) => {
      const food_name = food.label;
      const food_id = food.value;
      const food_data = {food_name: food_name, food_id: food_id};
      all_food_data.push(food_data);
    });

    var required_energy = 0.0;
    var required_protein_max = 0.0;
    var required_protein_min = 0.0;
    var required_vitamin_A_max = 0.0;
    var required_vitamin_A_min = 0.0;
    var required_vitamin_C_max = 0.0;
    var required_vitamin_C_min = 0.0;
    var required_vitamin_D_max = 0.0;
    var required_vitamin_D_min = 0.0;
    var required_vitamin_E_max = 0.0;
    var required_vitamin_E_min = 0.0;

    if(breast_feeding == 'Yes' || breast_feeding == 'Ndiyo'){
      if(total_months <= 24){
        nutritional_requirements_breastfed.some((energy_requirement) => {
          if(energy_requirement['Age'] == total_months){
            required_energy = parseFloat(energy_requirement['ENERGY_KC']);
            required_protein_max = parseFloat(energy_requirement['PROCNT_MAX']);
            required_protein_min = parseFloat(energy_requirement['PROCNT_MIN']);
            required_vitamin_A_max = parseFloat(energy_requirement['VITA_MAX']);
            required_vitamin_A_min = parseFloat(energy_requirement['VITA_MIN']);
            required_vitamin_C_max = parseFloat(energy_requirement['VITC_MAX']);
            required_vitamin_C_min = parseFloat(energy_requirement['VITC_MIN']);
            required_vitamin_D_max = parseFloat(energy_requirement['VITD_MAX']);
            required_vitamin_D_min = parseFloat(energy_requirement['VITD_MIN']);
            required_vitamin_E_max = parseFloat(energy_requirement['VITE_MAX']);
            required_vitamin_E_min = parseFloat(energy_requirement['VITE_MIN']);
            
            return true;
          } 
        });
      }
      else{
        nutritional_requirements_nonbreastfed.some((energy_requirement) => {
          if(energy_requirement['AGE'] == total_months){
            required_energy = parseFloat(energy_requirement['ENERGY_KC']);
            required_protein_max = parseFloat(energy_requirement['PROCNT_MAX']);
            required_protein_min = parseFloat(energy_requirement['PROCNT_MIN']);
            required_vitamin_A_max = parseFloat(energy_requirement['VITA_MAX']);
            required_vitamin_A_min = parseFloat(energy_requirement['VITA_MIN']);
            required_vitamin_C_max = parseFloat(energy_requirement['VITC_MAX']);
            required_vitamin_C_min = parseFloat(energy_requirement['VITC_MIN']);
            required_vitamin_D_max = parseFloat(energy_requirement['VITD_MAX']);
            required_vitamin_D_min = parseFloat(energy_requirement['VITD_MIN']);
            required_vitamin_E_max = parseFloat(energy_requirement['VITE_MAX']);
            required_vitamin_E_min = parseFloat(energy_requirement['VITE_MIN']);
              
            return true; 
          } 
        });
      }
    }

    else if(breast_feeding == 'No' || breast_feeding == 'Hapana'){
      nutritional_requirements_nonbreastfed.some((energy_requirement) => {
        if(energy_requirement['AGE'] == total_months){
          required_energy = parseFloat(energy_requirement['ENERGY_KC']);
          required_protein_max = parseFloat(energy_requirement['PROCNT_MAX']);
          required_protein_min = parseFloat(energy_requirement['PROCNT_MIN']);
          required_vitamin_A_max = parseFloat(energy_requirement['VITA_MAX']);
          required_vitamin_A_min = parseFloat(energy_requirement['VITA_MIN']);
          required_vitamin_C_max = parseFloat(energy_requirement['VITC_MAX']);
          required_vitamin_C_min = parseFloat(energy_requirement['VITC_MIN']);
          required_vitamin_D_max = parseFloat(energy_requirement['VITD_MAX']);
          required_vitamin_D_min = parseFloat(energy_requirement['VITD_MIN']);
          required_vitamin_E_max = parseFloat(energy_requirement['VITE_MAX']);
          required_vitamin_E_min = parseFloat(energy_requirement['VITE_MIN']);
            
          return true; 
        } 
      });
    }

    const energy_status = this.getSmartFeedingCombinations(all_food_data, required_energy,required_protein_min, required_protein_max, required_vitamin_A_max, required_vitamin_A_min, C_firstname, total_months, translation);
    message += energy_status;
    return message;
    
  }

  getEnergyStatus = (breast_feeding, breast_frequency, total_energy, required_energy, total_protein, required_protein_min, required_protein_max, C_firstname, total_months, translation, food_groups_ids) => {

    var message='';
    var warning='';
    var warning_display='';
    var message_display='';
    var all_food_combinations = [];
    var all_food_data = [];
    var deficiency_food_groups = [];
    var deficiency_food_groups_menu = [];
    var energy_deficiency_message = '';
    var food_groups_deficiency_message = null;
    var energy_deficiency = 0.0;
    var protein_deficiency_message = '';
    var protein_deficiency = 0.0;

    var protein_success_a = '';
    var protein_success_b = '';
    var protein_fail_a = '';
    var protein_fail_b = '';
    var protein_fail_c = '';
    var protein_deficiency_found_a = '';
    var protein_deficiency_found_b = '';
    var protein_deficiency_found_c = '';

    // Find deficiency groups
    deficiency_food_groups = food_groups.filter((food_group) => {
      if(food_groups_ids.includes(food_group['food_group_id']))
        return false;
      else
        return true;
    })
    // END Find deficiency groups

    // Find deficiency groups food list
    deficiency_food_groups.forEach((food_group) => {
      var group;
      var food_list;
      food_list = food.filter((fd) => {
        if(fd['food_group_id'] == food_group['food_group_id'])
          return true;
        else
          return false;
      })
      group = {
        group_name: food_group['group_name'],
        group_name_swahili: food_group['group_name_swahili'],
        group_menu: food_list
      };
      deficiency_food_groups_menu.push(group);
    })
    //END Find deficiency groups food list


    if(total_protein >= required_protein_min){
      protein_success_a = translation['feeding_practice_protein_success_a']+" "+total_protein+'g';
    }
    else{
      protein_fail_a = translation['feeding_practice_protein_warning_a']+" "+total_protein+'g';
      protein_fail_c = 'na protini '+required_protein_min+'g';
    }
    if(total_protein < required_protein_min){
      protein_deficiency_found_a = translation['feeding_practice_protein_deficiency_message_a']+" "+(required_protein_min - total_protein).toFixed(2)+'g';
      protein_deficiency_found_c = translation['feeding_practice_protein_deficiency_message_b'];
    }
    

    const status_results = {message: '',warning:'',message_display: '',warning_display: '', deficiency_food_groups_menu: [], food_groups_deficiency_message: null};
    if(total_energy >= required_energy && total_energy < (required_energy + (0.5*required_energy))){
      if(breast_feeding == 'Yes' || breast_feeding == 'Ndiyo'){
        message += C_firstname+" "+translation['feeding_practice_energy_success_a']+" "+total_energy+" "+protein_success_a+" "+translation['feeding_practice_energy_success_b']+" "+translation['feeding_practice_energy_success_c']+"</br>"+translation['feeding_practice_success_bigup_b'];
        warning_display = 'none';
      }
      else{
        message += C_firstname+" "+translation['feeding_practice_energy_success_a']+" "+total_energy+" "+protein_success_a+" "+"<br/>"+translation['feeding_practice_energy_success_b']+" "+translation['feeding_practice_energy_success_c']+"</br>"+translation['feeding_practice_success_bigup_b'];
        if(total_months < 6){
          warning += C_firstname+" "+translation['feeding_practice_bteastfeed_only_warning_c']+".";
        }
        else
          warning_display = 'none';
      }
    }
    else if(total_energy >= (required_energy + (0.5*required_energy))){      
      warning += C_firstname+" amelishwa chakula chenye jumla ya nishati "+total_energy.toFixed(2)+"KCal <br/>Kiasi hiki cha nishati ni kikubwa sana kwake <br/>"+C_firstname+" anatarajiwa kulishwa chakula chenye nishati "+required_energy+"KCal kwa siku";
      message_display = 'none'; 
    }
    else{
      energy_deficiency = required_energy - total_energy;
      energy_deficiency = parseFloat(energy_deficiency.toFixed(2));
      if(total_protein < required_protein_min){
        protein_deficiency = required_protein_min - total_protein;
        protein_deficiency = parseFloat(protein_deficiency.toFixed(2));
      }

      if(energy_deficiency > 0) {
        const foods = food;
        const quantifiers = food_quantifiers;
        const food_vs_quantifiers = food_combination;
        const food_indexes = [];
        var food_index = 0;
        var n = 0;
        var food_no = food_vs_quantifiers.length;
        const limit = 0;
        var i;
        for (i=0; i < food_no; i++) {
          if (n>2)
            break;
          if(food_indexes.includes(i))
            continue;
          var j;
          for (j=i+1; j < food_no; j++) {
            if(n>2)
              break;
            if(food_indexes.includes(i))
              break;
            if(food_indexes.includes(j))
              continue;
            var k;
            for(k=j+1; k < food_no; k++) {
              if(n>2)
                break;
              if(food_indexes.includes(i))
                break;
              if(food_indexes.includes(j))
                break;
              if(food_indexes.includes(k))
                continue;
              const combination = [];
              var combination_energy = 0;
              var combination_protein = 0;
              var first_food = {food: '', food_swahili: '', quantifier: '', quantifier_swahili: ''};
              var second_food = {food: '', food_swahili: '', quantifier: '', quantifier_swahili: ''};
              const third_food = {food: '', food_swahili: '', quantifier: '', quantifier_swahili: ''};
              foods.forEach((food) => {
                if(food['food_id'] == food_vs_quantifiers[i]['food_id']){
                  combination_energy += (food_vs_quantifiers[i]['grams']/100)*food['ENERGY_KC'];
                  combination_protein += (food_vs_quantifiers[i]['grams']/100)*food['PROCNT'];
                }
                else if(food['food_id'] == food_vs_quantifiers[j]['food_id']){
                  combination_energy += (food_vs_quantifiers[j]['grams']/100)*food['ENERGY_KC'];
                  combination_protein += (food_vs_quantifiers[j]['grams']/100)*food['PROCNT'];
                }
                else if(food['food_id'] == food_vs_quantifiers[k]['food_id']){
                  combination_energy += (food_vs_quantifiers[k]['grams']/100)*food['ENERGY_KC'];
                  combination_protein += (food_vs_quantifiers[k]['grams']/100)*food['PROCNT'];
                }
              });

              if ((combination_energy >= (energy_deficiency-0.5) && combination_energy <= (energy_deficiency+0.5)) && (combination_protein >= protein_deficiency)) {
                foods.forEach((food) => {
                  if(food['food_id'] == food_vs_quantifiers[i]['food_id']){
                    first_food['food'] = food['food_name'];
                    first_food['food_swahili'] = food['food_name_swahili'];
                  }
                  else if(food['food_id'] == food_vs_quantifiers[j]['food_id']){
                    second_food['food'] = food['food_name'];
                    second_food['food_swahili'] = food['food_name_swahili'];
                  }
                  else if(food['food_id'] == food_vs_quantifiers[k]['food_id']){
                    third_food['food'] = food['food_name'];
                    third_food['food_swahili'] = food['food_name_swahili'];
                  }
                });

                quantifiers.forEach((quantifier) => {
                  if(quantifier['food_quantifiers_id'] == food_vs_quantifiers[i]['food_quantifiers_id']){
                    first_food['quantifier'] = quantifier['food_quantifiers_name'];
                    first_food['quantifier_swahili'] = quantifier['food_quantifiers_name_swahili'];
                  }
                  if(quantifier['food_quantifiers_id'] == food_vs_quantifiers[j]['food_quantifiers_id']){
                    second_food['quantifier'] = quantifier['food_quantifiers_name'];
                    second_food['quantifier_swahili'] = quantifier['food_quantifiers_name_swahili'];
                  }
                  if(quantifier['food_quantifiers_id'] == food_vs_quantifiers[k]['food_quantifiers_id']){
                    third_food['quantifier'] = quantifier['food_quantifiers_name'];
                    third_food['quantifier_swahili'] = quantifier['food_quantifiers_name_swahili'];
                  }
                });
                combination[0] = first_food;
                combination[1] = second_food;
                combination[2] = third_food;
                combination[3] = parseFloat(combination_energy.toFixed(2));
                combination[4] = parseFloat(combination_protein.toFixed(2));
                all_food_combinations[n] = combination;
                n++;
                food_indexes[food_index] = i;
                food_index++;
                food_indexes[food_index] = j;
                food_index++;
                food_indexes[food_index] = k;
                food_index++;
              }
                    
            }
        
          }
      
        }
      
      }

      if(energy_deficiency > 0){
        const message_a = translation['feeding_practice_energy_deficiency_message_a'];
        const message_b = translation['feeding_practice_energy_deficiency_message_b'];
        // const message_c = translation['feeding_practice_energy_deficiency_message_c'];
        // const message_d = translation['feeding_practice_protein_deficiency_message_c'];

        //Feeding frequency calculation 
        if (translation['language'] == 'swahili') {
          var feeding_frequency_message = "Pamoja na kunyonya, "+C_firstname+" anatakiwa kula angalau";
          if(breast_feeding == 'Yes' || breast_feeding == 'Ndiyo'){
            if(total_months >= 6 && total_months <= 8){
              feeding_frequency_message += " mara 2 kwa siku.";
            }
            else if(total_months >= 9 && total_months <= 23){
              feeding_frequency_message += " mara  3 kwa siku.";
            }
          }
          else{
            if(total_months >= 6 && total_months <= 23){
              feeding_frequency_message += " mara 4 kwa siku.";
            }
            else if(total_months >= 24){
              feeding_frequency_message += " milo mikubwa mitatu(3) pamoja na visusio viwili(2) kwa siku.";
            }
          }
        }
        else{
          var feeding_frequency_message = "With breastfeeding, "+C_firstname+" is required to be fed atleast";
          if(breast_feeding == 'Yes' || breast_feeding == 'Ndiyo'){
            if(total_months >= 6 && total_months <= 8){
              feeding_frequency_message += " 2 times per day.";
            }
            else if(total_months >= 9 && total_months <= 23){
              feeding_frequency_message += " 3 times per day.";
            }
          }
          else{
            if(total_months >= 6 && total_months <= 23){
              feeding_frequency_message += " 4 times per day.";
            }
            else if(total_months >= 24){
              feeding_frequency_message += " three(3) main meal and two(2) snacks per day.";
            }
          }
        }
        //END Feeding frequency calculation

        energy_deficiency_message = jsxToString(
          <div><br/><div>{C_firstname+" "+message_a+" "+energy_deficiency+" KCal "+protein_deficiency_found_a}</div>
          <div>{feeding_frequency_message}</div><br/>
          {/* <div>{message_b+" "+protein_deficiency_found_c}</div> */}
          </div>
        );
      }
      // </Find required foods to fulfill the remaining energy>

      if(total_months >= 6) {
        if(breast_feeding == 'Yes' || breast_feeding == 'Ndiyo'){
          if(breast_frequency >= 5){
            message +=  translation['feeding_practice_frequency_success_b_a']+" "+C_firstname+" "+translation['feeding_practice_frequency_success_b_b']+"</br>"+translation['feeding_practice_success_bigup_b'];
            warning += C_firstname+" "+translation['feeding_practice_energy_warning_a']+" "+total_energy+"KCal "+protein_fail_a+" <br/> "+C_firstname+" "+translation['feeding_practice_energy_warning_d']+" "+required_energy +"KCal "+protein_fail_c+" "+translation['feeding_practice_energy_warning_e']+".";
            warning += energy_deficiency_message;
          }
          else{
            warning += '<font color="#aa0000">'+translation['feeding_practice_warning_unbigup_a']+'</font><br/>'+C_firstname+' '+translation['feeding_practice_energy_warning_a']+' '+total_energy+'KCal '+protein_fail_a+'<br/> '+C_firstname+' '+translation['feeding_practice_energy_warning_d']+' '+required_energy+'KCal '+protein_fail_c+' '+translation['feeding_practice_energy_warning_e']+'<br/>'+translation['feeding_practice_frequency_success_a']+','+translation['feeding_practice_frequency_warning_a_a']+' '+C_firstname+' '+translation['feeding_practice_frequency_warning_a_b']+'</br>'+translation['feeding_practice_frequency_warning_b']+' '+C_firstname+' '+translation['feeding_practice_frequency_warning_c_5']+'.</br> '+translation['feeding_practice_warning_unbigup_b_a']+' '+translation['feeding_practice_warning_unbigup_b_b'];
            warning += energy_deficiency_message;
            message_display = 'none';
          }
        }
        else{
          warning += C_firstname+" "+translation['feeding_practice_energy_warning_a']+" "+total_energy+"KCal "+protein_fail_a+"<br/> "+C_firstname+" "+translation['feeding_practice_energy_warning_d']+" "+required_energy+"KCal "+protein_fail_c+" "+translation['feeding_practice_energy_warning_e']+"</br>"+translation['feeding_practice_warning_unbigup_b_a']+" "+translation['feeding_practice_warning_unbigup_b_b'];
          warning += energy_deficiency_message;
          message_display = 'none';
        }
        // warning += food_groups_deficiency_message;
      }
      else{
        warning += C_firstname+" "+translation['feeding_practice_bteastfeed_only_warning_c']+".";
        message_display = 'none';
      }
      
    }
    //</Out of range energy problem>


    //Find missing food for balanced diet
    if(food_groups_ids.length < 4){
      var c=1;
      if (translation['language'] == 'swahili') {

        food_groups_deficiency_message = jsxToString(
          <div>
            <div>{"Pia "+C_firstname+" amepewa mlo ambao sio kamili."}</div>
            <div>{"Tafadhali muongezee "+C_firstname+" angalau makundi "+(4 - food_groups_ids.length)+" miongoni mwa makundi ya vyakula hapa chini ili kutimiza mlo kamili."}</div>
            <div>{"Chagua chakula kimoja kwa kila kundi la chakula miongoni mwa makundi ya vyakula hapa chini,"}</div>
            <div>{"Kisha bonyeza kitufe kilichoandikwa 'Pata mpangilio wa vyakula ulivyochagua' ili kupata kiasi cha kumlisha "+C_firstname+" kwa kila chakula."}</div>
          </div>
        );
      }
      else{

        food_groups_deficiency_message = jsxToString(
          <div>
            <div>{"Also "+C_firstname+" has given a diet which is not balanced."}</div>
            <div>{"Please add to "+C_firstname+" atleast "+(4 - food_groups_ids.length)+" groups among food groups below so as to fulfill a balanced diet."}</div>
            <div>{"choose one food for each food group you select,"}</div>
            <div>{"Then click a button labeled 'Get a food combination of all food which you have selected' to get amount needed to feed "+C_firstname+"  for each food."}</div>
          </div>
        );
      }
    }
    //END Find missing food for balanced diet

    status_results['message'] = message;
    status_results['warning'] = warning;
    status_results['message_display'] = message_display;
    status_results['warning_display'] = warning_display;
    status_results['deficiency_food_groups_menu'] =  deficiency_food_groups_menu;

    if(total_months >= 6) {
      status_results['food_groups_deficiency_message'] = food_groups_deficiency_message;
    }

    return status_results;

  }

  getFeedingStatus = (feedingInfo, Child, User, age, translation) => {

    var energy_status = [];
    var all_food_combinations = [];
    var all_food_data = [];
    var energy_deficiency_message = '';
    var total_energy = 0.0;
    var total_protein = 0.0;
    var total_vitamin_A = 0.0;
    var total_vitamin_C = 0.0;
    var total_vitamin_D = 0.0;
    var total_vitamin_E = 0.0;
    var energy_deficiency = 0.0;
    var protein_deficiency = 0.0;
    var vitamin_A_deficiency = 0.0;
    var vitamin_C_deficiency = 0.0;
    var vitamin_D_deficiency = 0.0;
    var vitamin_E_deficiency = 0.0;

    var required_energy = 0.0;
    var required_protein_max = 0.0;
    var required_protein_min = 0.0;
    var required_vitamin_A_max = 0.0;
    var required_vitamin_A_min = 0.0;
    var required_vitamin_C_max = 0.0;
    var required_vitamin_C_min = 0.0;
    var required_vitamin_D_max = 0.0;
    var required_vitamin_D_min = 0.0;
    var required_vitamin_E_max = 0.0;
    var required_vitamin_E_min = 0.0;

    const food_groups_ids = [];

    var message = '';
    var warning = '';
    var message_display = false;
    var warning_display = false;
    var  deficiency_food_groups_menu = [];
    var food_groups_deficiency_message = null;
    

    const breast_feeding = feedingInfo.breast_feeding;
    const breast_frequency = feedingInfo.breast_frequency;
    const meal_feeding = feedingInfo.meal_feeding;
    const total_no = feedingInfo.total_no;
    
    const total_months = age.total_months

    if(breast_frequency === null)
        breast_frequency = 0;

    var child_progress_id = JSON.parse(localStorage.getItem('child_progress_id'));;
    if(child_progress_id===null)
        child_progress_id = child_progress_id = 0;

    var j;
    for(j=1;j<=total_no;j++){
      const name =feedingInfo[`food_name${j}`];
      const food_id=feedingInfo[`food_id${j}`];
      const quantity=feedingInfo[`quantity${j}`];
      const quantity_frequency=feedingInfo[`quantity_frequency${j}`];
      const consistency=feedingInfo[`consistency${j}`];
      const time=feedingInfo[`time${j}`];
      const food_data = {name: name, food_id: food_id, quantity: quantity, quantity_frequency: quantity_frequency, consistency: consistency, time: time};
      all_food_data.push(food_data);

    }

    const feeding_data = {breast_feeding: breast_feeding, breast_frequency: breast_frequency, meal_feeding: meal_feeding, total_no: total_no, food_data: all_food_data};

    all_food_data.forEach((food_data) =>{
      food.forEach((food) => {

        if(food['food_id'] == food_data['food_id']){
          const gram = food_data['quantity_frequency']*food_data['quantity'];
          const k_calories = (gram/100)*food['ENERGY_KC'];
          total_energy += parseFloat(k_calories.toFixed(2));
          const protein = (gram/100)*food['PROCNT'];
          total_protein += parseFloat(protein.toFixed(2));
          const vitamin_A = (gram/100)*food['VITA'];
          total_vitamin_A += parseFloat(vitamin_A.toFixed(2));
          const vitamin_C = (gram/100)*food['VITC'];
          total_vitamin_C += parseFloat(vitamin_C.toFixed(2));
          const vitamin_D = (gram/100)*food['VITD'];
          total_vitamin_D += parseFloat(vitamin_D.toFixed(2));
          const vitamin_E = (gram/100)*food['VITE'];
          total_vitamin_E += parseFloat(vitamin_E.toFixed(2));

          if(!food_groups_ids.includes(food['food_group_id']))
            food_groups_ids.push(food['food_group_id']);
        }
        
      });
      
    });

    total_energy += breast_frequency * 25; //25 comes from 200/8;

    if(breast_feeding == 'Yes' || breast_feeding == 'Ndiyo'){
      if(total_months <= 24){
        nutritional_requirements_breastfed.some((energy_requirement) => {
          if(energy_requirement['Age'] == total_months){
            required_energy = parseFloat(energy_requirement['ENERGY_KC']);
            required_protein_max = parseFloat(energy_requirement['PROCNT_MAX']);
            required_protein_min = parseFloat(energy_requirement['PROCNT_MIN']);
            required_vitamin_A_max = parseFloat(energy_requirement['VITA_MAX']);
            required_vitamin_A_min = parseFloat(energy_requirement['VITA_MIN']);
            required_vitamin_C_max = parseFloat(energy_requirement['VITC_MAX']);
            required_vitamin_C_min = parseFloat(energy_requirement['VITC_MIN']);
            required_vitamin_D_max = parseFloat(energy_requirement['VITD_MAX']);
            required_vitamin_D_min = parseFloat(energy_requirement['VITD_MIN']);
            required_vitamin_E_max = parseFloat(energy_requirement['VITE_MAX']);
            required_vitamin_E_min = parseFloat(energy_requirement['VITE_MIN']);

            const energy_status = this.getEnergyStatus(breast_feeding,breast_frequency, total_energy, required_energy, total_protein, required_protein_min, required_protein_max, Child.first_name, total_months, translation, food_groups_ids);
            message += energy_status['message'];
            warning += energy_status['warning'];
            message_display = energy_status['message_display'];
            warning_display = energy_status['warning_display'];
            deficiency_food_groups_menu =  energy_status['deficiency_food_groups_menu'];
            food_groups_deficiency_message = energy_status['food_groups_deficiency_message'];
            
            return true; 
          } 
        });
      }
      else{
        nutritional_requirements_nonbreastfed.some((energy_requirement) => {
          if(energy_requirement['AGE'] == total_months){
            required_energy = parseFloat(energy_requirement['ENERGY_KC']);
            required_protein_max = parseFloat(energy_requirement['PROCNT_MAX']);
            required_protein_min = parseFloat(energy_requirement['PROCNT_MIN']);
            required_vitamin_A_max = parseFloat(energy_requirement['VITA_MAX']);
            required_vitamin_A_min = parseFloat(energy_requirement['VITA_MIN']);
            required_vitamin_C_max = parseFloat(energy_requirement['VITC_MAX']);
            required_vitamin_C_min = parseFloat(energy_requirement['VITC_MIN']);
            required_vitamin_D_max = parseFloat(energy_requirement['VITD_MAX']);
            required_vitamin_D_min = parseFloat(energy_requirement['VITD_MIN']);
            required_vitamin_E_max = parseFloat(energy_requirement['VITE_MAX']);
            required_vitamin_E_min = parseFloat(energy_requirement['VITE_MIN']);

            const energy_status = this.getEnergyStatus(breast_feeding,breast_frequency, total_energy, required_energy, total_protein, required_protein_min, required_protein_max, Child.first_name, total_months, translation, food_groups_ids);
            message += energy_status['message'];
            warning += energy_status['warning'];
            message_display = energy_status['message_display'];
            warning_display = energy_status['warning_display'];
            deficiency_food_groups_menu =  energy_status['deficiency_food_groups_menu'];
            food_groups_deficiency_message = energy_status['food_groups_deficiency_message'];
            
            return true; 
          } 
        });
      }
    }

    else if(breast_feeding == 'No' || breast_feeding == 'Hapana'){
      nutritional_requirements_nonbreastfed.some((energy_requirement) => {
        if(energy_requirement['AGE'] == total_months){
          required_energy = parseFloat(energy_requirement['ENERGY_KC']);
          required_protein_max = parseFloat(energy_requirement['PROCNT_MAX']);
          required_protein_min = parseFloat(energy_requirement['PROCNT_MIN']);
          required_vitamin_A_max = parseFloat(energy_requirement['VITA_MAX']);
          required_vitamin_A_min = parseFloat(energy_requirement['VITA_MIN']);
          required_vitamin_C_max = parseFloat(energy_requirement['VITC_MAX']);
          required_vitamin_C_min = parseFloat(energy_requirement['VITC_MIN']);
          required_vitamin_D_max = parseFloat(energy_requirement['VITD_MAX']);
          required_vitamin_D_min = parseFloat(energy_requirement['VITD_MIN']);
          required_vitamin_E_max = parseFloat(energy_requirement['VITE_MAX']);
          required_vitamin_E_min = parseFloat(energy_requirement['VITE_MIN']);

          const energy_status = this.getEnergyStatus(breast_feeding,breast_frequency, total_energy, required_energy, total_protein, required_protein_min, required_protein_max, Child.first_name, total_months, translation, food_groups_ids);
          message += energy_status['message'];
          warning += energy_status['warning'];
          message_display = energy_status['message_display'];
          warning_display = energy_status['warning_display'];
          deficiency_food_groups_menu =  energy_status['deficiency_food_groups_menu'];
          food_groups_deficiency_message = energy_status['food_groups_deficiency_message'];

          return true; 
        } 
      });
    }

    // $temp_message = $input->sanitizeString($message);
    // $temp_warning = $input->sanitizeString($warning);

    this.updateFeedingMessages(message,warning,breast_feeding,breast_frequency,feeding_data,total_energy,total_protein,total_vitamin_A,total_vitamin_C,total_vitamin_D,total_vitamin_E,child_progress_id,Child,User,age);
    //   return this.state.response.error;

      // const display = 'none';
      // const suggestion = 'yes';
      // let message=message;
      // let warning=warning;
      // let message_display = message_display;
      // let warning_display = warning_display;
      this.state.response.feeding_message = message;
      this.state.response.feeding_warning = warning;
      this.state.response.message_display =  message_display;
      this.state.response.warning_display = warning_display;
      this.state.response.deficiency_food_groups_menu =  deficiency_food_groups_menu;
      this.state.response.food_groups_deficiency_message =  food_groups_deficiency_message;
      this.state.response.food_groups_ids =  food_groups_ids;

      const feeding_nutrients = {total_energy: total_energy,required_energy: required_energy,total_protein: total_protein,required_protein_max: required_protein_max,required_protein_min: required_protein_min,total_vitamin_A: total_vitamin_A,total_vitamin_C: total_vitamin_C,total_vitamin_D: total_vitamin_D,total_vitamin_E: total_vitamin_E,required_vitamin_A_max: required_vitamin_A_max,required_vitamin_C_max: required_vitamin_C_max,required_vitamin_D_max: required_vitamin_D_max,required_vitamin_E_max: required_vitamin_E_max,required_vitamin_A_min: required_vitamin_A_min,required_vitamin_C_min: required_vitamin_C_min,required_vitamin_D_min: required_vitamin_D_min,required_vitamin_E_min: required_vitamin_E_min};

      this.state.response.feeding_nutrients = feeding_nutrients;
      return this.state.response;

    // $display='feeding_result';
    // $child->setSession('suggestion',$suggestion);
    // $child->setSession('feeding_data',$feeding_data);
    // header("location: ?navigator=BMI&display=$display");
  
  }

  create = (data, Child, User, age, Translator) => {

    this.resetState();
    let weight = data.weight;
    let height = data.height;

    //Make weight to decimal point
    let weight_int = Math.floor(weight);
    let weight_dec = weight - weight_int;
    weight = weight_int+weight_dec;

    let height_int = Math.floor(height);
    let height_dec = height - height_int;

    if(height_dec >= 0.1 && height_dec < 0.6)
      height = height_int+0.5;
    else if(height_dec >= 0.6)
      height = height_int+1;
    else
      height = height_int;
    
    //convert weight and height to 1 decimal point
    height = height.toFixed(1);
    weight = weight.toFixed(1);

   

    return this.confirmGrowth(weight, height, Child.sex, age.total_months, Child.first_name, Translator,Child.child_id).then((response) => {
      
      if(!response)
        return this.state.response;
      else{

        return this.addProgress(weight,height,'','','','','','','','','','','','','','',Child.child_id,age.total_months,age.total_weeks,age.total_days,Translator, User.key, Child.key).then((response) => {
          
          if(!response)
            return this.state.response;
          else{
            
            if(this.state.response.found_problem){

              const warning = this.state.response.growth_problem_message;
              const problem = this.state.response.growth_problem;
              const warning_problem = warning+" "+problem;
              this.state.response.warning_problem = warning_problem;

              return this.updateBmiMessages('',warning_problem,this.state.response.insertID, User.key, Child.key).then((response) => {

                if(!response)
                  return this.state.response;
                else{
                  this.state.response.problem_submitted = true;
                  return this.state.response;
                }

              }).catch((error) => {
                alert(error);
              });

            }
            else{
              const message = this.state.response.growth_message;
              return this.updateBmiMessages(message,'',this.state.response.insertID, User.key, Child.key).then((response) => {
                if(!response)
                  return this.state.response;
                else
                  return this.state.response;
              }).catch((error) => {
                alert(error);
              });
            }

          }

        }).catch((error) => {
          alert(error);
        });          

      }

    }).catch((error) => {
        alert(error);
    });


    // const { weight, height } = this.state;

    // this.ref.add({
    //   weight,
    //   height
    // }).then((docRef) => {
    //   this.setState({
    //     weight: '',
    //     height: ''
    //   });
    //   this.props.history.push("/")
    // })
    // .catch((error) => {
    //   console.error("Error adding document: ", error);
    // });

    // if(!navigator.onLine)
    //   this.props.history.push("/")
  }
}

export const FeedingController = new Feeding();